import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule} from  '@angular/material/select';
import { MatTooltipModule} from  '@angular/material/tooltip';
import { MatButtonToggleModule } from  '@angular/material/button-toggle';

import { LayoutComponent } from './layout/layout.component';
import { ProfileImageDialogComponent } from './layout/profile-image-dialog.component';
import {FieldErrorDisplayModule} from './field-error-display/field-error-display.module';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import {MatDatepickerModule} from '@angular/material/datepicker';

import {PopupModule} from './popup/popup.module';

import {MatNativeDateModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatButtonModule} from '@angular/material/button';

import {MatSortModule} from '@angular/material/sort';
import {MatDialogModule,MatDialogContent} from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table'  
import {MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import{MatCheckboxModule} from '@angular/material/checkbox';
import { ToastrModule } from 'ngx-toastr';
import {DragDropModule} from '@angular/cdk/drag-drop';

//import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {NgxPaginationModule} from 'ngx-pagination';
import {LoaderModule} from './shared/loader/loader.module';
import { HttpServiceInterceptor } from './././Services/httpservice.interceptor';
//import { TimelineModule} from './shared/timeline/timeline.module';
  import { from } from 'rxjs';
  import { TranslateModule, TranslateLoader } from '@ngx-translate/core';  
  import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
  import {  HttpClient } from '@angular/common/http';
  import {MatTabsModule} from '@angular/material/tabs';
  import {MatRadioModule} from '@angular/material/radio';
  import {MatAutocompleteModule} from '@angular/material/autocomplete';
  import {MatExpansionModule} from '@angular/material/expansion';
  import { ProgressComponent } from './progress/progress.component';
import { DndDirective } from './shared/dnd.directive';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CurrencyDirective } from './shared/currency.directive';
import {SharedModule} from './shared/shared.module';
import {MatSlideToggleModule } from '@angular/material/slide-toggle';

//import { FooterComponent } from './layout/footer/footer.component';



//import { FullCalendarModule } from '@fullcalendar/angular'; // for FullCalendar!  

 // import {TimelineModule} from './shared/timeline/timeline.module';
  export function HttpLoaderFactory(http: HttpClient) {  
    return new MultiTranslateHttpLoader(http, [  
      { prefix: "./assets/i18/", suffix: ".json" },  
    ]);  
  }  

@NgModule({
  exports: [
     
    //DragDropModule,
     MatSelectModule,
     MatDatepickerModule,
     MatNativeDateModule,
     MatButtonToggleModule,
     MatDialogModule,
     MatTableModule,
     MatExpansionModule,
     MatPaginatorModule,
     MatSortModule,
     MatTableModule,
     MatButtonModule,
     MatFormFieldModule,
     MatInputModule,
     MatPaginatorModule,
     MatMenuModule,
     MatCheckboxModule,
     MatTabsModule,
     MatTooltipModule,
     MatRadioModule,
     MatAutocompleteModule,
     DragDropModule,
     MatSlideToggleModule
     //DndDirective, ProgressComponent
    
  ],
  declarations: [],
  imports: [],
 
})
export class MaterialModule { }

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        NoopAnimationsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        // FullCalendarModule,
        HttpModule,
        FieldErrorDisplayModule,
        PopupModule,
        //  TimelineModule,
        LoaderModule,
        NgxPaginationModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        MaterialModule,
        CKEditorModule,
        SharedModule
    ],
    declarations: [
        AppComponent,
        LayoutComponent,
        ProfileImageDialogComponent,
        DndDirective,
        ProgressComponent,
        CurrencyDirective
    ],
    // providers: [DatePipe],
    providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: HttpServiceInterceptor,
            multi: true
        },
        { provide: DatePipe, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
